// extracted by mini-css-extract-plugin
export default {"cls1":"XExaTq2lDF0KJb7ahkqQ","cls2":"cEHHr8WBIP1UZcSw6aeX XExaTq2lDF0KJb7ahkqQ"};